import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup }        from '@angular/forms';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

@Component({
  selector: 'df-question',
  encapsulation: ViewEncapsulation.None,
  template: `
    <div [class]="'form-group ' + question.key" [id]="question.key + '-group'"
      *ngIf="question.showField === undefined ? true : question.showField"
      [class.has-error]="isNotValid || question.errorTrigger" [class.has-valid]="isValid" [class.needs-input]="needsInput"
      [formGroup]="form">
      <template #tooltipTemplate><div [innerHtml]="question.tooltip"></div></template>
      <div [ngSwitch]="question.tag">
        <button *ngSwitchCase="'button'" [id]="question.key" type="button" [disabled]="question.disabled"
                [class]="question.class" (click)="question.fn(form, template, question.key)">
                <span *ngIf="question.btnImg" [class]="question.btnImg" aria-hidden="true"></span>
            {{question.value}}
        </button>

        <div *ngSwitchCase="'checkbox'" class="checkbox" >
          <label class="control-label" [attr.for]="question.key">
            <input [formControlName]="question.key" [id]="question.key" type="checkbox" [class]="question.class">
            <span [innerHTML]="question.label"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip-checkbox">
                {{question.tooltipLink}}
                <span *ngIf="!question.tooltipLink" class="tooltip-icon">?</span>
            </a>
          </label>
        </div>

        <div *ngSwitchCase="'dropdown'" >
          <label *ngIf="question.label" class="control-label" [attr.for]="question.key">
            <span [innerHTML]="question.label !== ' ' ? question.label : '\u00a0'"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip">
                <span class="tooltip-icon" (mouseenter)="(question.fn)? question.fn(question.key): undefined">?</span>
            </a>
          </label>
          <div class="input-container">
            <select [id]="question.key" [formControlName]="question.key" [class]="'form-control ' + question.class" [attr.disabled]="question.disabled">
              <option value="" selected disabled>{{question.placeholder || ''}}</option>
              <option *ngFor="let opt of question.options" [value]="opt.key" [disabled]="opt.disabled" [innerHTML]="opt.value"></option>
            </select>
          </div>
        </div>

        <div *ngSwitchCase="'radio'" [id]="question.key" class="radio-group">
          <label *ngIf="question.label" [class]="'control-label ' + (question.labelClass || '')" [attr.for]="question.key">
            <span [innerHTML]="question.label !== ' ' ? question.label : '\u00a0'"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip">
              <span class="tooltip-icon" (mouseenter)="(question.fn)? question.fn(question.key): undefined">?</span>
            </a>
            <p class="help-block" *ngIf="question.helper">{{question.helper}}</p>
          </label>
          <div class="input-container">
            <div *ngFor="let opt of question.options" [class]="'radio-option ' + (question.type || '')">
              <label [class.opt-valid]="isChecked(opt.key)">
                <input [formControlName]="question.key" type="radio" [name]="question.key" [value]="opt.key" [class]="question.class" [attr.disabled]="opt.disabled">
                <span [innerHTML]="opt.value"></span>
                <a *ngIf="opt.tooltip" [placement]="question.placement || 'top'" [tooltip]="opt.tooltip" class="custom-tooltip">
                  <span class="tooltip-icon" (mouseenter)="(question.fn)? question.fn(question.key): undefined">?</span>
                </a>
                <div class="option-helper" *ngIf="opt.helper">
                  <div *ngFor="let line of opt.helper.split('\n')">{{line}}</div>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="'text'" >
          <label *ngIf="question.label" class="control-label" [attr.for]="question.key">
            <span [innerHTML]="question.label !== ' ' ? question.label : '\u00a0'"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip-checkbox">
              <span class="tooltip-icon" (mouseenter)="(question.fn)? question.fn(question.key): undefined">?</span>
            </a>
          </label>
          <div [class]="question.format !== 'percentage' ? 'input-container' : 'input-group'">
            <input *ngIf="question.format !== 'currency'" [formControlName]="question.key" [id]="question.key" [attr.disabled]="question.disabled"
                  [attr.readonly]="question.readonly" [type]="question.type" [class]="'form-control ' + question.class"
                  [placeholder]="question.placeholder || ''" [format]="question.format">
            <input *ngIf="question.format === 'currency'" [formControlName]="question.key" [id]="question.key" [attr.disabled]="question.disabled"
                  [attr.readonly]="question.readonly" [type]="question.type" [class]="'form-control ' + question.class"
                  [placeholder]="question.placeholder || ''" [textMask]="{mask: currencyMask}">
            <span *ngIf="question.format === 'percentage'" class="input-group-addon">%</span>
          </div>
        </div>

        <div *ngSwitchCase="'textarea'" >
          <label *ngIf="question.label" class="control-label" [attr.for]="question.key">
            <span [innerHTML]="question.label !== ' ' ? question.label : '\u00a0'"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip">
                <span class="tooltip-icon">?</span>
            </a>
          </label>
          <div class="input-container">
            <textarea [formControlName]="question.key" [id]="question.key" [rows]="question.rows"
                  [class]="'form-control ' + question.class" [attr.readonly]="question.readonly"
                  [placeholder]="question.placeholder || ''"></textarea>
          </div>
        </div>

        <div *ngSwitchCase="'title'" >
          <div [id]="question.key" [class]="'section-header ' + question.class"><span [innerHTML]="question.label"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip">
                <span class="tooltip-icon">?</span>
            </a>
          </div>
        </div>

        <div *ngSwitchCase="'subtitle'" >
          <div [id]="question.key" [class]="'subtitle ' + question.class"><span [innerHTML]="question.label"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip">
                <span class="tooltip-icon">?</span>
            </a>
          </div>
        </div>

        <div *ngSwitchCase="'typeahead'" >
          <label *ngIf="question.label" class="control-label" [attr.for]="question.key">
            <span [innerHTML]="question.label !== ' ' ? question.label : '\u00a0'"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip">
                <span class="tooltip-icon">?</span>
            </a>
          </label>
          <div class="input-container">
            <input [formControlName]="question.key" [id]="question.key" [class]="'form-control ' + question.class"
                    [placeholder]="question.placeholder || ''" [attr.readonly]="question.readonly" [typeahead]="question.options"
                    [typeaheadOptionField]="question.typeaheadOptionField || ''" (typeaheadOnSelect)="typeaheadOnSelect($event)"
                    [typeaheadMinLength]="question.typeaheadMinLength || 0" [typeaheadOptionsLimit]="question.typeaheadOptionsLimit || 100"
                    (blur)="typeaheadOnBlur($event)" [attr.disabled]="question.disabled">
          </div>
        </div>

        <div *ngSwitchCase="'industry'" class="industrySelect">
          <label *ngIf="question.label" class="control-label" [attr.for]="question.key">
            <span [innerHTML]="question.label !== ' ' ? question.label : '\u00a0'"></span>
            <a *ngIf="question.tooltip" [placement]="question.placement || 'top'" [tooltip]="tooltipTemplate" class="custom-tooltip">
                <span class="tooltip-icon">?</span>
            </a>
          </label>
          <div class="input-container">
            <input *ngIf="!viewFull" [formControlName]="question.key" [id]="question.key" [class]="'form-control ' + question.class"
                    [placeholder]="question.placeholder || ''" [attr.readonly]="question.readonly" [typeahead]="question.categories"
                    [typeaheadOptionField]="question.typeaheadOptionField || ''" (typeaheadOnSelect)="tableOnSelect($event)"
                    [typeaheadMinLength]="question.typeaheadMinLength || 0" [typeaheadOptionsLimit]="question.typeaheadOptionsLimit || 100"
                    (blur)="typeaheadOnBlur($event)" [attr.disabled]="question.disabled"
                    (typeaheadNoResults)="changeY($event)">
            <div *ngIf="this.form.controls[this.question.key].value.length > 0 && viewBtn && !viewFull"
              class="view-full" [style.bottom]="noResultsY + 'px'"
              [style.border-top-right-radius]="typeaheadNoResults ? '5px' : '0'"
              [style.border-top-left-radius]="typeaheadNoResults ? '5px' : '0'">
              <div *ngIf="typeaheadNoResults" class="empty-list">...Can't seem to find it?</div>
              <a (mousedown)="viewFullTable(true)" class="empty-btn">View Full List</a>
            </div>
            <div *ngIf="viewFull" class="table-container row">
              <div class="table-border col-sm-6">
                <h4 class="table-header">{{question.label1}}</h4>
                <div class="table-view">
                  <div *ngFor="let opt of question.options">
                    <a class="table-btn table-hover" [innerHTML]="opt.value"
                    [class.table-active]="selected === opt.key"
                    (click)="selectTable(opt)"></a>
                  </div>
                </div>
              </div>
              <div class="table-border col-sm-6">
                <h4 class="table-header">{{question.label2}}</h4>
                <div class="table-view">
                  <div *ngFor="let opt of categories">
                    <a class="table-btn table-category" [innerHTML]="opt.value"
                    (click)="selectCategory(opt)"></a>
                  </div>
                </div>
              </div>
              <div class="align-right">
                <a (click)="viewFullTable(false)">Cancel</a>
              </div>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="'error'" >
          <div [id]="question.key" [class]="'errorMessage ' + question.class"><span [innerHTML]="question.message"></span></div>
        </div>

        <div *ngSwitchCase="'fieldError'" >
          <div *ngIf="form.controls[question.field] && form.controls[question.field].errors" [id]="question.key" [class]="'errorMessage ' + question.class"><span [innerHTML]="question.message"></span></div>
        </div>

        <p class="help-block" *ngIf="question.helper"><span [innerHTML]="question.helper"></span></p>
      </div>
      <div class="errorMessage" *ngIf="errors">{{errors.message || 'This field is required.'}}</div>
    </div>
  `,
  styles: [`
    a {
      cursor: pointer;
    }

    .align-right {
      text-align: right;
    }

    .industrySelect {
      .input-container {
        position: relative;
      }
    }

    .empty-list {
      border-bottom: 1px solid rgba(0,0,0,.15);
      padding: 10px;
    }

    .empty-btn {
      text-align: center;
      display: block;
      padding: 5px;
    }

    .tooltip-icon {
      display: inline-block;
      border: 1px solid #337ab7;
      border-radius: 50%;
      width: 17px;
      height: 17px;
      font-size: 12px;
      color: #337ab7;
      text-align: center;
    }

    .view-full {
      display: block;
      position: absolute;
      background: white;
      width: 100%;
      z-index: 1000;
      border: 1px solid rgba(0,0,0,.15);
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      box-shadow: 0 6px 12px rgba(0,0,0,.175);
    }

    .table {
      margin: 0;
      .col-sm-6 {
        padding: 0;
      }
      &-container {
        margin: 0;
      }
      &-border {
        border: 1px solid #cccccc;
      }
      &-view {
        height: 250px;
        overflow: scroll;
      }
      &-header {
        padding-left: 10px;
      }
      &-btn {
        transition: .3s;
        display: block;
        text-align: left;
        width: 100%;
        padding: 10px;
        border: none;
        color: black;
        text-decoration: none;
      }
      &-category {
        &:hover {
          color: #158cbf;
          background: white;
        }
      }
      &-hover {
        &:hover {
          color: white;
          background: #158cbf;
        }
      }
      &-active {
        color: white;
        background: #158cbf;
      }
    }
  `],
})
export class DynamicFormQuestionComponent implements OnInit{
  @Input() question: any;
  @Input() form: FormGroup;
  @Input() template: any = {};
  @Input() prefill: any;

  // Industry Select
  viewBtn = false;
  typeaheadNoResults = false;
  viewFull = false;
  selected = '';
  categories = [];
  noResultsY = -230;

  currencyMask = createNumberMask({
    prefix: '$'
  });

  ngOnInit() {
    if (this.question.tag === 'industry') {
      this.form.controls[this.question.key].valueChanges.subscribe(data => {
        if (this.form.controls[this.question.key].value.length > 0) this.viewBtn = true;
      });
    }
  }

  typeaheadOnSelect(e) {
    this.touchFieldAndUpdate();
  }

  typeaheadOnBlur(e) {
    this.viewBtn = false;
    if (e.target.value.length !== this.form.controls[this.question.key].value.length)
      this.touchFieldAndUpdate();
  }

  tableOnSelect(e) {
    this.touchFieldAndUpdate();
    this.viewBtn = false;
  }
  changeviewBtn(e: boolean): void {
    this.viewBtn = e;
  }
  viewFullTable(e: boolean): void {
    this.viewFull = e;
    this.viewBtn = false;
  }
  selectTable(obj): void {
    this.selected = obj.key;
    this.categories = obj.categories;
  }
  selectCategory(obj): void {
    this.form.controls[this.question.key].setValue(obj.value);
    this.viewFull = false;
    this.viewBtn = false;
  }
  changeY(e): void{
    this.noResultsY = e ? -75 : -230;
    this.typeaheadNoResults = e;
  }

  get errors() {
    if (this.form.controls[this.question.key])
      return (this.form.controls[this.question.key].errors
      && this.form.controls[this.question.key].touched === true) ?
       this.form.controls[this.question.key].errors : '';
   }
  get isValid() {
    if (this.form.controls[this.question.key])
      return (this.form.controls[this.question.key].valid === true
      && (this.form.controls[this.question.key].touched === true
        || (this.prefill && this.prefill[this.question.key])));
  }
  get isNotValid() {
    if (this.form.controls[this.question.key])
      return (this.form.controls[this.question.key].valid === false
      && this.form.controls[this.question.key].touched === true
      && this.form.controls[this.question.key].status !== 'DISABLED'
      && this.question.disabled !== true);
  }
  get needsInput() {
    if (this.form.controls[this.question.key])
      return (Object.keys(this.prefill).length !== 0
              && !this.prefill[this.question.key]
              && this.form.controls[this.question.key].touched === false
              && this.form.controls[this.question.key].status !== 'DISABLED'
              && this.question.disabled !== true);
  }

  isChecked(value) {
    if (this.form.controls[this.question.key])
      return (this.form.controls[this.question.key].value === value);
  }

  private touchFieldAndUpdate() {
    this.form.controls[this.question.key].markAsTouched();
    this.form.controls[this.question.key].updateValueAndValidity();
  }
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
